import React from 'react';
import FieldRow from "./FieldRow.js";
import AdvancedFieldsRow from "./AdvancedFields.js";
import useSchemaStore from '../../store/schemaStore';

const FieldTableData = () => {
  const { fields } = useSchemaStore();

  return (
    <table className="table">
      <thead>
        <tr>
          <th>Field Name</th>
          <th>Input Type <a className="infolink" href="/db-schema-generator/#/datatypes" target="_blank" rel="noopener noreferrer"> </a>
          </th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {fields.map((field, index) => (
          <React.Fragment key={`field-${index}`}>
            <FieldRow field={field} index={index} />
            <AdvancedFieldsRow index={index} field={field} />
          </React.Fragment>
        ))}
      </tbody>
    </table>
  );
};

export default FieldTableData;